import { createSelector } from 'reselect';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const dialogSelector = (state: any) => state.dialog;

export const isOpenSelector = createSelector(dialogSelector, (dialog) => dialog.isOpen);
